// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__Hep3F","box":"style_box__Wj2wz","active":"style_active__EZjIn","title":"style_title__8OZ52","item":"style_item__hWp5j"};